export const LeftArrow = () => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.7071 9.29289C20.0976 9.68342 20.0976 10.3166 19.7071 10.7071L14.4142 16L19.7071 21.2929C20.0976 21.6834 20.0976 22.3166 19.7071 22.7071C19.3166 23.0976 18.6834 23.0976 18.2929 22.7071L12.2929 16.7071C11.9024 16.3166 11.9024 15.6834 12.2929 15.2929L18.2929 9.29289C18.6834 8.90237 19.3166 8.90237 19.7071 9.29289Z'
      fill='#64748B'
    />
  </svg>
);

export const RightArrow = () => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.2929 22.7071C11.9024 22.3166 11.9024 21.6834 12.2929 21.2929L17.5858 16L12.2929 10.7071C11.9024 10.3166 11.9024 9.68342 12.2929 9.29289C12.6834 8.90237 13.3166 8.90237 13.7071 9.29289L19.7071 15.2929C20.0976 15.6834 20.0976 16.3166 19.7071 16.7071L13.7071 22.7071C13.3166 23.0976 12.6834 23.0976 12.2929 22.7071Z'
      fill='#64748B'
    />
  </svg>
);
